import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

export default createUseStyles(
  {
    wrapper: {
      display: 'flex',
      gap: 20,

      '& > *': {
        position: 'relative',
        textDecoration: 'none',
        userSelect: 'none',
        cursor: 'pointer',
        pointerEvents: 'all',
        color: theme.colors.textPrimary,

        '&:not(:last-child)': {
          color: theme.colors.textLink,
          '&:hover': {
            textDecoration: 'underline',
          },
          '&:active': {
            textDecoration: 'underline',
            color: theme.colors.textPrimary,
          },
          '&:after': {
            content: "'|'",
            position: 'absolute',
            top: 0,
            right: -12,
            fontSize: 12,
            lineHeight: 20 / 12,
            color: theme.colors.textPrimary,
          },
        },
      },
    },
    item: {},
  },
  {
    name: 'Breadcrumbs',
  },
);
